import React from "react";
import { DatePicker, Form, Icon, Tooltip } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";
import { TimeHelper } from "@xala/common-services";
import moment from "moment";
import { Space } from "antd";

export const ScheduledOnField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="ScheduledOn"
      label={<Space>
        <span>{t("NOTIFICATION_SCHEDULEDON_FIELD")}</span>
        <Tooltip className="text-danger ml-2" title={t("NOTIFICATION_SCHEDULEDON_TOOLTIP")}>
          <Icon type="question-circle" />
        </Tooltip>
      </Space>}
      key="ScheduledOn"
      initialValue={
        isEditMode && notification?.ScheduledOn
          ? TimeHelper.parse(notification?.ScheduledOn)
          : undefined
      }
    >
      <DatePicker
        showTime={true}
        placeholder={t("NOTIFICATION_SCHEDULEDON_INPUT_FIELD")}
        style={{ width: "100%" }}
        disabledDate={(current) => current && current < moment()}
      />
    </Form.Item>
  );
};
